// ENG-21411: geometry for maximising the video popup on the OPENER's current
// monitor. The old code did moveTo(0,0)/resizeTo, where (0,0) is the PRIMARY
// display's origin — on a multi-monitor setup that yanked the popup to the wrong
// screen and left a black leftover window. availLeft/availTop are the current
// screen's offset in the same coordinate space window.moveTo uses, so moving there
// keeps the popup on the opener's screen. Mirrors staff-app/src/store/nhs.ts.
export interface FullscreenGeometry {
  left: number;
  top: number;
  width: number;
  height: number;
}

export function fullscreenGeometry(scr: Screen = window.screen): FullscreenGeometry {
  return {
    left: scr.availLeft ?? 0,
    top: scr.availTop ?? 0,
    width: scr.availWidth,
    height: scr.availHeight,
  };
}

// window.open features. Chrome often ignores width/height here (we still enforce
// them with moveTo/resizeTo after opening), but they hint the initial placement.
export function fullscreenWindowFeatures(geo: FullscreenGeometry = fullscreenGeometry()): string {
  return `popup,menubar=no,location=no,resizable=yes,scrollbars=no,status=no,top=${geo.top},left=${geo.left},width=${geo.width},height=${geo.height}`;
}
